import React, { useEffect } from "react";
import PropTypes from "prop-types";
import CustomButton from "../CustomButton";
import { trackGrowNetworkNudgeShown, trackGrowNetworkNudgeClicked } from "../../utils/analytics";

const GrowNetworkNudge = ({ onImport, onDismiss }) => {
  useEffect(() => {
    trackGrowNetworkNudgeShown();
  }, []);

  const handleImport = () => {
    trackGrowNetworkNudgeClicked();
    onImport();
  };

  return (
    <div className="gn-nudge" role="dialog" aria-label="Grow your network">
      <div className="gn-nudge-content">
        <p>
          Know more people who might be a fit? Import your contacts to grow
          your network.
        </p>
        <div className="gn-nudge-actions">
          <CustomButton
            text="Import Contacts"
            backgroundColor="#3A6ED4"
            color="#fff"
            handleClick={handleImport}
          />
          <button
            type="button"
            className="gn-nudge-close"
            onClick={onDismiss}
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

GrowNetworkNudge.propTypes = {
  onImport: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default GrowNetworkNudge;
